// extracted by mini-css-extract-plugin
export default {"control":"select_control__lhV3I","placeholder":"select_placeholder__5PLtT","menu":"select_menu__iOx3f"};